import { render, staticRenderFns } from "./WidgetsBrand.vue?vue&type=template&id=488c061c&scoped=true&"
import script from "./WidgetsBrand.vue?vue&type=script&lang=js&"
export * from "./WidgetsBrand.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsBrand.vue?vue&type=style&index=0&id=488c061c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488c061c",
  null
  
)

export default component.exports